import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import CustomDialog from './inputs/CustomDialog'
// import TemplatePreview from './TemplatePreview'
import InstaTable from './InstaTable'
// import RedeemIcon from './Mui/RedeemIcon'
import CouponIcon from './Mui/CouponIcon'
import VoucherIcon from './Mui/VoucherIcon'

import {
  businesses_index,
  activate_business,
  deactivate_business,
  clear_business,
  delete_business,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.business
  return {
    business: state.business,
    businesses: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getBusinesses: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( businesses_index(page, per_page, filters, sort, order) ),
    activateBusiness: (business_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(activate_business(business_id, index, page, per_page, filters, sort, order)),
    deactivateBusiness: (business_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(deactivate_business(business_id, index, page, per_page, filters, sort, order)),
    clearBusiness: () => dispatch( clear_business() ),
    setPath: path => dispatch( set_path(path) ),
  }
}

class ConnectedBusinessesIndex extends React.Component {
  state={
    current_business: null,
    current_view: 'all',
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at" ) {
      renderText = item[field] ? new Date(item[field]).toLocaleDateString() : ''
    } else if (field === "active") {
      renderText = item[field] ? this.statusIcon("active") : this.statusIcon("inactive")
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { this.editLink(item, state) }
          { item.active && this.deactivateLink(item, state) }
          { !item.active && this.activateLink(item, state) }
          {
            this.couponsLink(item)
            // coupons
          }
          {
            this.vouchersLink(item)
            // vouchers
          }
          { this.peopleLink(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getBusinesses } = this.props
    getBusinesses()
    this.props.setPath('businesses')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.business.fetching && !this.props.business.fetching && this.props.business.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else if (value === "active") {
      this.setState({merge_filters: {active: true}})
    } else {
      this.setState({merge_filters: {active: false}})
    }
    this.setState({current_view: value})
  }

  editLink = item => {
    const {id} = item
    return (
      <Link to ={`/businesses/${id}/edit`} className="action-btn" title="Edit" onClick={this.props.clearBusiness}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
      </Link>
    )
  }

  activateLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Publish Business" onClick={e=>{
        e.preventDefault()
        this.props.activateBusiness(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
      </Link>
    )
  }

  deactivateLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    const title = "Deactivate Business"
    const icon  = "insert_drive_file"
    // const icon  = item.status === "revoked" ? "restore_page" : "insert_drive_file"
    return (
      <Link to="" className="action-btn" title={title}onClick={e=>{
        e.preventDefault()
        this.props.deactivateBusiness(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>{icon}</Icon>
      </Link>
    )
  }

  hideDialog() {
    this.setState({showDialog: false, current_business: {}})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'active') {
      icon = 'check_circle'
    } else {
      icon = 'insert_drive_file'
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  showPreview = item => {
    // this.setState({showPreview: true, current_template: template})
  }

  couponsLink = (item) => {
    const {longid, coupons} = item
    if (coupons === 0) {
      return (
        <Link to='' style={{padding: '15px 5px 5px 5px', cursor: 'not-allowed'}} title="No coupons yet" disabled onClick={e => {e.preventDefault()}}>
          <CouponIcon style={{color: 'rgba(0,0,0,0.6)', fontSize: '16px'}} />
        </Link>
      )
    }

    return (
      <Link to={`/coupons/business?business=${longid}`} className="action-btn" title="Coupons" target="_blank">
        <CouponIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} />
      </Link>
    )
  }

  vouchersLink = (item) => {
    const {longid, vouchers} = item
    if (vouchers === 0) {
      return (
        <Link to='' style={{padding: '15px 5px 5px 5px', cursor: 'not-allowed'}} title="No vouchers yet" disabled onClick={e => {e.preventDefault()}}>
          <VoucherIcon style={{color: 'rgba(0,0,0,0.6)', fontSize: '16px'}} />
        </Link>
      )
    }

    return (
      <Link to={`/vouchers/business?business=${longid}`} className="action-btn" disabled={item.vouchers && item.vouchers === 0} title="Vouchers" target="_blank">
        <VoucherIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} />
      </Link>
    )
  }

  peopleLink = (item) => {
    const {current_user} = this.props
    if (current_user.role === "admin" ) {
      const {longid, managers} = item
      if (managers === 0) {
        return (
          <Link to='' style={{padding: '15px 5px 5px 5px', cursor: 'not-allowed'}} title="No users yet" disabled onClick={e => {e.preventDefault()}}>
            <Icon style={{color: 'rgba(0,0,0,0.6)', fontSize: '16px'}}>people</Icon>
          </Link>
        )
      }

      return (
        <Link to={`/users/business?business=${longid}`} className="action-btn" title="Users" target="_blank">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>people</Icon>
        </Link>
      )
    }
    return ''
  }


  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { businesses, pagination, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'name', disablePadding: true, label: 'Name' },
      { id: 'notes', disablePadding: true, label: 'Notes', disableSort: true },
      { id: 'active', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'created_at', disablePadding: true, label: 'Creation' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Active", value: totals.active },
      { name: "inactive", label: "Inactive", value: totals.inactive },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.business.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Businesses
          </Typography>
          <CustomOutlinedButton
            component={Link}
            to="/businesses/new"
            className="buttonnoto c-blue align-self-center"
            onClick={e=> this.props.setPath("addbusinessn")}
            >Add Business
          </CustomOutlinedButton>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={businesses}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="ID, name, notes"
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getBusinesses.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="businesses"
          addClassField="status"
        />

        {
          // <CustomDialog
          //   id="delete-dialog"
          //   fullScreen = {false}
          //   qid={this.state.current_id}
          //   isopen={this.state.showDialog}
          //   handleClose={this.hideDialog.bind(this)}
          //   handleAccept={this.destroy.bind(this)}
          //   title="Delete Business?"
          // >
          //   This action cannot be undone
          // </CustomDialog>
        }

      </div>
    )
  }
}

const BusinessesIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedBusinessesIndex)

export default withStyles(styles)(BusinessesIndex)



// WEBPACK FOOTER //
// ./src/js/components/BusinessesIndex.js